import Vue from 'vue'
import Vuex from 'vuex'
import uploadFile from './uploadFile'
import imageRating from './imageRating'
import imageFlag from './imageFlag'
import inviteUser from './inviteUser'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
      uploadFile,
      imageRating,
      imageFlag,
      inviteUser,


    }
})



// WEBPACK FOOTER //
// ./src/store/index.js